import { useWorkspaces } from '@components/Dashboard/hooks'
import { Checkbox } from '@lib/components'
import type { TeammateDto } from '@store/reducers/dashboard/types'
import type React from 'react'

import { clsJoin } from '@/utils'
import { Divider, UserToggle } from './components'
import { useAccessUpdate } from './hooks'
import css from './styles.module.css'
import { findFolder, takeAccessState } from './utils'

type Props = {
  closeButton: React.ReactNode
  folderId: string
}

export const FolderVisibility: React.FC<Props> = ({
  closeButton,
  folderId,
}) => {
  const { current } = useWorkspaces()

  const folder = findFolder(current, folderId)
  const { publicAccess, disabled, members, checked } = takeAccessState(
    folder,
    current?.members || []
  )

  const { onPublic, onToggle } = useAccessUpdate(folder, current?.id)

  if (!folder) {
    return null
  }

  return (
    <div className={css.modal}>
      <div className={css.modal_close}>{closeButton}</div>

      <h2 className={css.title}>Folder visibility</h2>

      <div className={css.body}>
        <p className={css.subtitle}>
          Who can see the{' '}
          <span className={css.folder_name}>{folder?.title}</span>?
        </p>

        <div className={css.members}>
          <div className={css.all_members_row}>
            <Checkbox
              checked={publicAccess}
              onChange={onPublic}
              label="All team members"
            />
          </div>
          <div
            className={clsJoin(css.members_list, publicAccess && css.disabled)}
          >
            <Divider />
            {members.map((m: TeammateDto) => (
              <UserToggle
                onChange={onToggle}
                checked={checked.includes(m.id)}
                disabled={disabled.includes(m.id)}
                member={m}
                key={m.id}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
